/** Hit points as text, temporary ones after: "9/13 +5 temp". */
export function hitPointsText(health: { hp: number; maxHp: number; temporaryHp: number }) {
  return `${Math.round(health.hp)}/${Math.round(health.maxHp)}${health.temporaryHp > 0 ? ` +${Math.round(health.temporaryHp)} temp` : ''}`;
}
/** A health bar's two widths in percent: hit points and temporary ones after them, sharing the bar when together they exceed the maximum. */
export function hitPointsWidths(health: { hp: number; maxHp: number; temporaryHp: number }) {
  const hp = Math.max(0, health.hp), temporary = Math.max(0, health.temporaryHp), whole = Math.max(1, health.maxHp, hp + temporary);
  return { hp: hp / whole * 100, temporary: temporary / whole * 100 };
}
